import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { useI18n, useTranslation } from '../i18n';
import { brandName } from '../lib/brand';
import LocaleSwitcher from '../i18n/LocaleSwitcher';

export default function Login() {
  const { signIn, signUp } = useAuth();
  const t = useTranslation();
  const { locale } = useI18n();
  const location = useLocation();

  // Preserve a `returnTo` if the user was deep-linked to /login from a guarded
  // page, e.g. /login?returnTo=/wan22-video. Falls back to '/'.
  const params = new URLSearchParams(location.search);
  const returnTo = params.get('returnTo') || '/';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
        <LocaleSwitcher />
      </Box>

      <Paper sx={{ maxWidth: 420, width: '100%', p: { xs: 4, md: 5 } }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" sx={{ fontSize: 24, mb: 0.5 }}>
            {brandName(locale)}
          </Typography>
          <Typography variant="body2">{t.login.subtitleSignIn}</Typography>
        </Box>

        <Stack spacing={2}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={() => signIn(returnTo)}
          >
            {t.login.signIn}
          </Button>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            onClick={() => signUp(returnTo)}
          >
            {t.login.createAccount}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
